module.exports = __webpack_public_path__ + "img/user-icon-default.275d37d8.svg";